import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/",
)({
  beforeLoad: () => {
    throw redirect({ to: "/apps/alerts/shadow-it/apps" });
  },
});
